export const selectFolderModalTitle = 'Select folder/subfolder';
